<template>

    <div class="page-content">
        <div class="container-fluid">

            <Breadcrumb
                :pgTitle="$t('nav.notifications')"
                :pgIcon="'bx bx-bell'"
                :refs="refs"
                :addNew="addNew">
            </Breadcrumb>

            <Loading
                v-if="pgLoading">
            </Loading>

            <div v-if="!pgLoading">
                <div 
                    v-for="(item, idx) in items"
                    :key="idx"
                    class="alert "
                    :class="[(item.status) ? 'alert-danger' : 'alert-success', 
                            ($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : '']"
                    style="width: 100%">
                    <!-- <p>
                        <img v-if="item.employee" 
                            :src="(item.employee) ? item.employee.image : ''" 
                            style="width:30px;height: 30px;border-radius: 50%;margin-left: 5px;">
                        {{ item.employee.name }}
                    </p> -->
                    <!-- <span v-if="item.loading" style="float:left">
                        <span 
                            class="spinner-grow spinner-grow-sm mr-2"
                            style="margin-top: 12px;" 
                            role="status" 
                            aria-hidden="true">
                        </span>
                    </span>
                    <button 
                        v-if="!item.loading"
                        type="button"
                        @click="item.loading = true; deleteItem(item.encrypt_id)"
                        class="btn btn-danger btn-rounded" 
                        style="float: left"
                        :title="$t('role.delete')">
                        <i class="fa fa-trash"></i>
                    </button> -->
                    <p style="font-size: 17px">{{ item.title }}</p>
                    <p v-html="item.body"></p>
                </div>
            </div>

        </div>
    </div>

</template>

<script>
import iziToast from 'izitoast';

export default {
    name: 'Notify',
    components: {
        Breadcrumb: () => import('@/components/Breadcrumb.vue'),
        Loading: () => import('@/components/Loading.vue'),
    },
    data(){
        return {    
            // auth
            auth: {
                access_token: '',
            },

            addNew: false,
            pgLoading: true,
            items: [],
            refs: 'notifications',
        }
    },
    watch: {},
    mounted() {},
    created() {
        // AccessToken
        if(localStorage.getItem('access_token')) {
            this.auth.access_token = localStorage.getItem('access_token');
        }

        this.fetchNotificationLogs();
    },
    methods: {
        //
        fetchNotificationLogs(){
            this.pgLoading = true;
            this.axios.defaults.headers.common = {
                'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                'Authorization': `Bearer ` + this.auth.access_token,
                'locale' : this.$i18n.locale
            };
            const options = {
                url: window.baseURL+'/'+this.refs+'/logs',
                method: 'GET',
                data: {}
            }
            this.axios(options)
            .then(res => {
                this.pgLoading = false;
                this.items = res.data.data.rows;
            })
            .catch(err => {

                // 403 Forbidden
                if(err.response && err.response.status == 401) {
                    this.clearLocalStorage();
                    this.$router.push({ name: 'login' });
                } else if(err.response && err.response.status == 403) {
                    this.$router.push({ name: 'forbidden' });
                } else {
                    this.btnLoading = false;
                    iziToast.warning({
                        icon: 'bx bx-angry',
                        title: '',
                        message: (err.response) ? err.response.data.message : ''+err
                    });
                }

            })
            .finally(() => {});
        },

        // clear Local Storage
        clearLocalStorage() {
            localStorage.removeItem('access_token');
            localStorage.removeItem('avatar');
            localStorage.removeItem('username');
            localStorage.removeItem('encrypt_id');
            localStorage.removeItem('role');
        },


        deleteItem(id) {
            if(confirm('Are you sure?')) {
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer `+this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/'+this.refs+'/logs/'+id,
                    method: 'DELETE',
                    data: {},
                }
                this.axios(options)
                .then(() => {
                    this.fetchNotificationLogs(); 
                    iziToast.success({
                        icon: 'bx bx-wink-smile',
                        title: '',
                        message: 'تم الحذف بنجاح',
                    }); 
                })
                .catch(err => {
                    this.fetchNotificationLogs(); 
                    iziToast.error({
                        icon: 'bx bx-angry',
                        title: '',
                        message: (err.response) ? err.response.data.message : ''+err
                    });
                })
                .finally(() => {});
            } else { 
                // in case pressed cancel
                this.fetchNotificationLogs(); 
            }
        },

    },
}
</script>
